<template>
  <v-navigation-drawer app dark v-model="drawer" class="left-sidebar" :width="sizeLeftSidebar">
    <v-list class="pa-0">
      <v-list-item class="px-2 hidden-md-and-up">
        <v-app-bar-nav-icon large @click.stop="drawer = !drawer" app class="hidden-md-and-up"></v-app-bar-nav-icon>
      </v-list-item>
      <v-list-item>
        <img src="@/assets/logo_tesfri_white.png" alt="TS" class="logo" />
      </v-list-item>
    </v-list>

    <!-- Menu sur grand ecran -->
    <v-list dense flat nav class="hidden-sm-and-down">
      <v-list-item to="/Home" link>
        <v-list-item-icon>
          <v-icon large>mdi-home</v-icon>
        </v-list-item-icon>

        <v-list-item-title class="moduleItemText pl-3">Accueil</v-list-item-title>
      </v-list-item>

      <v-list-group
        active-class="tesfriRaspberry--text"
        v-for="(moduleItem, index) in modulesSousModules"
        :key="moduleItem + '-' + index"
        prepend-icon-color="dark"
        no-action
      >
        <template v-slot:activator>
          <v-list-item-action>
            <v-icon large v-text="moduleItem.iconClass"></v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="moduleItemText" v-text="moduleItem.moduleName"></v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          class="pl-8"
          v-for="(subModuleItem, subindex) in moduleItem.subModules"
          :key="subModuleItem + '-' + subindex"
          :to="subModuleItem.subModulepath"
          active-class="tesfriRaspberry--text"
        >
          <v-list-item-action>
            <v-icon v-text="subModuleItem.iconClass"></v-icon>
          </v-list-item-action>
          <v-list-item-title v-text="subModuleItem.subModuleName"></v-list-item-title>
        </v-list-item>
      </v-list-group>
    </v-list>

    <!-- Menu petit ecran -->
    <v-list dense flat nav class="hidden-md-and-up">
      <v-list-item to="/Home" link>
        <v-list-item-icon>
          <v-icon>mdi-home</v-icon>
        </v-list-item-icon>

        <v-list-item-title class="moduleItemText">Accueil</v-list-item-title>
      </v-list-item>

      <v-list-group
        active-class="tesfriRaspberry--text"
        v-for="(moduleItem, index) in modulesSousModules"
        :key="moduleItem + '-' + index"
        prepend-icon-color="dark"
        no-action
      >
        <template v-slot:activator>
          <v-list-item-action>
            <v-icon v-text="moduleItem.iconClass"></v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="moduleItemText" v-text="moduleItem.moduleName"></v-list-item-title>
          </v-list-item-content>
        </template>
        <v-container pa-0>
          <v-row dense>
            <v-col v-for="(subModuleItem, subindex) in moduleItem.subModules" :key="subModuleItem + '-' + subindex" cols="4" class="ma-0 ">
              <v-list-item :to="subModuleItem.subModulepath" active-class="tesfriRaspberry--text" class="ma-0.5 buttonMenu">
                <v-list-item-content class="d-flex align-content-space-between" style="height: 100px;">
                  <v-icon v-text="subModuleItem.iconClass" x-large></v-icon>
                  <div class="mt-auto">{{ subModuleItem.subModuleName }}</div>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-container>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "app-menu",
  computed: {
    ...mapState("userContext", ["rights"]),
    drawer: {
      get() {
        return this.$store.getters.leftDrawerState;
      },
      set(state) {
        return this.$store.commit("CHANGE_LEFT_DRAWER", state);
      }
    },
    modulesSousModules() {
      //Liste des modules et sous modules disponible
      let routeList = this.$router.options.routes;

      let modules = routeList
        .filter(element => "meta" in element && "type" in element.meta && element.meta.type === "module")
        .map(mod => {
          return {
            moduleName: mod.meta.breadcrumb[0].text,
            subModules: mod.children.map(sub => {
              return {
                subModuleName: sub.meta.breadcrumb[0].text,
                subModulepath: `${mod.path}/${sub.path}`,
                iconClass: sub.meta.iconClass,
                rightName: sub.meta.rightName
              };
            }),
            modulePath: `${mod.path}`,
            iconClass: mod.meta.iconClass
          };
        });

      return modules
        .map(moduleName => this.filterSubModules(moduleName)) //filtrage des sous modules avec les droits
        .filter(moduleName => moduleName.subModules.length > 0); // filtrage des module vide
    },

    sizeLeftSidebar() {
      // taille de la barre de gauche en fonction du device
      if (this.$vuetify.breakpoint.mobile) {
        return "100vw";
      } else {
        return "256";
      }
    }
  },
  methods: {
    ...mapActions("userContext", ["updateCurrentWarehouse", "updateCurrentCompany", "updateCurrentCompanyWarehouse", "logout"]),
    // Filtrage des sous modules avec les droits utilisateur
    filterSubModules(element) {
      element.subModules = element.subModules.filter(subModule => {
        let accepted = false;

        accepted = this.rights.includes(subModule.rightName);

        return accepted;
      });

      return element;
    },

    close() {
      //Fermture du menu side bar
      // TODO : modifier la fermeture pour la rendre active seulement sur un mobile
      this.$root.$emit("bv::toggle::collapse", "app-menu");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "app-menu.scss";
</style>
